module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_france.d78d43c9.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_france.png
// module id = 1252
// module chunks = 16